import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { select, Store } from '@ngrx/store';
import clone from 'just-clone';
import { Observable } from 'rxjs';
import { filter, map, share, startWith, tap } from 'rxjs/operators';
import { IStatusMessage } from '../../../shared';
import { SelectItem } from '../../../shared/efaact-primeng.module';
import { IShowErrors } from '../../../shared/errors-sidenav';
import { LoggingService } from '../../../shared/services/logging/logging.service';
import * as fromStore from '../store';
import { FacilityAllocation } from '../store/facility-allocation.model';
import * as reducer from '../store/facility-allocation.reducer';
import * as selectors from '../store/facility-allocation.selectors';
@Component({
    selector: 'ef-facility-container',
    templateUrl: './facility-container.component.html',
    styleUrls: ['./facility-container.component.scss'],
    standalone: false
})
export class FacilityContainerComponent implements OnInit {
    facilityAllocation$: Observable<FacilityAllocation[]>;
    showAllocationWarning$: Observable<boolean>;
    facilityAllocationTypes$: Observable<SelectItem[]>;
    allocationType$: Observable<number>;
    @Input() selectedError: IStatusMessage;
    @Output() public ShowError = new EventEmitter<IShowErrors>();

    constructor(
        private store: Store<reducer.State>,
        private log: LoggingService
    ) {
        this.store.dispatch(fromStore.getFacilityAllocations());
        this.store.dispatch(fromStore.getFacilityAllocationTypes());
    }

    ngOnInit() {
        this.facilityAllocation$ = this.store.pipe(
            select(selectors.selectAll),
            share(),
            map(x => clone(x))
        );
        this.allocationType$ = this.store.pipe(
            select(selectors.selectAll),
            share(),
            filter(x => !!x && x.length > 0),
            map(x => x[0].Allocationtypeid),
            filter(x => !!x),
            startWith(1),
            tap(allocationType =>
                this.log.verbose({
                    type: 'FacilityContainerComponent',
                    allocationType
                })
            )
        );
        this.facilityAllocationTypes$ = this.store.pipe(
            select(selectors.selectFacilityAllocationTypes)
        );
    }
    onSaveFacilityAllocation($event: FacilityAllocation) {
        this.log.verbose({
            type: 'FacilityContainerComponent:onSaveFacilityAllocation',
            $event
        });
        this.store.dispatch(
            fromStore.putFacilityAllocations({ facilityAllocations: [$event] })
        );
    }
}
